<template>
  <div>
    <div>
      <div class="align-items-right">
        <p class="title text-right">
          <strong> ДОГОВОР СТРАХОВАНИЯ </strong>
        </p>
        <p class="title text-right">
          <strong> №: {{ doc.DocumentID }} </strong>
        </p>
      </div>

      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <div class="float-right">
            <div>
              <table class="table table-bordered">
                <tr>
                  <td>
                    <strong>Класс страхования </strong>
                  </td>
                  <td>
                    Добровольное страхование гражданско-правовой ответственности
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Вид страхования</strong>
                  </td>
                  <td>
                    Добровольное страхование гражданско-правовой ответственности
                    перевозчиков и экспедиторов
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div style="display: flex; justify-content: space-between">
          <div class="col-md-12">
            <div>&laquo;{{ day }}&raquo; {{ month }} {{ year }} г.</div>
          </div>
        </div>
      </div>
      <p style="text-align: justify">
        Настоящим Страховщик и Страхователь, совместно именуемые стороны
        заключили настоящий договор страхования (далее – Договор, Договор
        страхования) о нижеследующем:
      </p>
      <p style="display: flex; justify-content: center">
        <strong> РАЗДЕЛ I. Основные условия договора </strong>
      </p>

      <table class="table table-bordered">
        <tr>
          <td>1.1.</td>
          <td>
            Страховщик (наименование, БИН, банковские реквизиты, место
            нахождения, телефон/факс, сектор экономики)
          </td>
          <td>
            {{ insurer.organizations.org_name }},
            {{ insurer.organizations.org_code }} <br />
            {{ getBankData() }} <br />
            {{ getAddress() }}, <br />
            {{ insurer.persons.person_phone_number }}
          </td>
        </tr>
        <tr>
          <td>1.2.</td>
          <td>Страхователь:</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>наименование</td>
          <td>{{ insurance.policy_holder_name }}</td>
        </tr>
        <tr>
          <td></td>
          <td>фактический и юридический адрес</td>
          <td>{{ insurance.policy_holder_address }}</td>
        </tr>
        <tr>
          <td></td>
          <td>ИИН/БИН</td>
          <td>{{ insurance.policy_holder_bin }}</td>
        </tr>
        <tr>
          <td></td>
          <td>банковские реквизиты</td>
          <td>{{ insurance.policy_holder_bank }}</td>
        </tr>
        <tr>
          <td></td>
          <td>Телефон /E-mail</td>
          <td>
            {{ insurance.policy_holder_phone }},
            {{ insurance.policy_holder_email }}
          </td>
        </tr>
        <tr>
          <td></td>
          <td>сектор экономики,</td>
          <td>{{ insurance.economy_sector }}</td>
        </tr>
        <tr>
          <td></td>
          <td>вид экономической деятельности</td>
          <td>{{ insurance.activity_type }}</td>
        </tr>
        <tr>
          <td></td>
          <td>признак резидентства</td>
          <td>{{ insurance.is_resident }}</td>
        </tr>
        <tr>
          <td></td>
          <td>№ и дата выдачи лицензии</td>
          <td>{{ insurance.license_no }}</td>
        </tr>

        <tr>
          <td>1.3.</td>
          <td>Территориальный признак объекта</td>
          <td>{{ insurance.object_teritory }}</td>
        </tr>
        <tr>
          <td>1.4.</td>
          <td>Застрахованный:</td>
          <td>{{ insurance.insured_details }}</td>
        </tr>
        <tr>
          <td>1.5.</td>
          <td>Третьи лица</td>
          <td></td>
        </tr>
        <tr>
          <td>1.6.</td>
          <td>
            Сведения о транспортном средстве: Модель / название /
            регистрационный номер / серия / номер двигателя / номер кузова / год
            выпуска
          </td>
          <td>
            Страхователь предоставляет Страховщику информацию по каждой
            перевозке (до фактической перевозки) по форме, установленной
            Приложением №1 к Договору страхования, посредством электронной почты
            на электронный адрес Страховщика либо контактного лица от имени
            Страховщика.
          </td>
        </tr>
        <tr>
          <td rowspan="4">1.7.</td>
          <td>Страховая сумма, вид валюты (цифрами и прописью) общая</td>
          <td>{{ getFullSum() }} тенге</td>
        </tr>
        <tr>
          <td>По риску «Утрата (гибель)» и/или «Повреждение груза»:</td>
          <td>{{ insurance.cargo_insured_sum }}</td>
        </tr>
        <tr>
          <td>По риску «Причинение вреда жизни, здоровью третьих лиц»:</td>
          <td>{{ insurance.life_insured_sum }}</td>
        </tr>
        <tr>
          <td>По риску «Причинение вреда имуществу третьих лиц»:</td>
          <td>{{ insurance.property_insured_sum }}</td>
        </tr>

        <tr>
          <td>1.7.1</td>
          <td>
            Страховая ёмкость (максимальная стоимость всех перевозок,
            осуществляемых в период действия Договора страхования)
          </td>
          <td>{{ insurance.total_insured_sum }}</td>
        </tr>

        <tr>
          <td rowspan="4">1.8.</td>
          <td>Страховая премия, вид валюты (цифрами и прописью) общая</td>
          <td></td>
        </tr>
        <tr>
          <td>По риску «Утрата (гибель)» и/или «Повреждение груза»:</td>
          <td>-</td>
        </tr>
        <tr>
          <td>По риску «Причинение вреда жизни, здоровью третьих лиц»:</td>
          <td>-</td>
        </tr>
        <tr>
          <td>По риску «Причинение вреда имуществу третьих лиц»:</td>
          <td>-</td>
        </tr>
        <tr>
          <td>1.9.</td>
          <td>Франшиза</td>
          <td>{{ insurance.franchise }}</td>
        </tr>
        <tr>
          <td>1.10.</td>
          <td>Вид валюты</td>
          <td>тенге</td>
        </tr>
        <tr>
          <td>1.11.</td>
          <td>Территория действия страховой защиты</td>
          <td>{{ insurance.insurance_teritory }}</td>
        </tr>
        <tr>
          <td>1.12.</td>
          <td>Порядок и сроки уплаты страховой премии</td>
          <td>{{ insurance.payout_term }}</td>
        </tr>
        <tr>
          <td>1.13.</td>
          <td>Срок действия Договора страхования</td>
          <td>{{ insurance.insurance_term }}</td>
        </tr>

        <tr>
          <td>1.14.</td>
          <td>Срок действия страховой защиты</td>
          <td>
            Страхователь предоставляет Страховщику информацию по каждой
            перевозке (до фактической перевозки) по форме, установленной
            Приложением №1 к Договору страхования, посредством электронной почты
            на электронный адрес Страховщика либо контактного лица от имени
            Страховщика. При этом ответственность Страховщика распространяется
            на все перевозки, задекларированные в период действия Договора
            страхования, в том числе и после прекращения срока действия Договора
            страхования.
          </td>
        </tr>

        <tr>
          <td>1.15.</td>
          <td>Особые условия</td>
          <td>
            Страхователь должен предоставлять Страховщику информацию по каждой
            перевозке (до фактической перевозки) по форме, установленной
            Приложением №1 к Договору страхования, посредством электронной почты
            на электронный адрес Страховщика либо контактного лица от имени
            Страховщика. Общий размер страховых сумм по всем перевозкам не
            должен превышать установленного размера страховой ёмкости по
            Договору страхования. Достижение размера (полное исчерпание)
            страховой ёмкости по Договору страхования ведет к прекращению
            Договора страхования. Страхователь имеет право увеличить размер
            страховой ёмкости путем доплаты страховой премии в размере,
            установленном Страховщиком. При этом в случае недостижения
            (неисчерпания) размера страховой ёмкости по Договору страхования в
            течение срока действия Договора страхования, возврат премии
            Страхователю не осуществляется. Стороны договорились и согласились,
            что предельный объем ответственности Страховщика по Договору
            страхования установлен размером страховой суммы, указанной в пункте
            1.7. Договора страхования. В случае пролонгации Договора страхования
            на новый период, по согласованию сторон, остаток неизрасходованной
            страховой ёмкости может быть перенесён на новый договор.
          </td>
        </tr>

        <tr>
          <td>1.16.</td>
          <td>
            Страховой агент ФИО, контактный номер телефона и ИИН (если им
            является физическое лицо-резидент Республики Казахстан)
            Наименование, местонахождение, контактный номер телефона БИН (если
            им является юридическое лицо-резидент Республики Казахстан)
          </td>
          <td>
            {{ insurance.insurer_name }}, <br />
            {{ insurance.insurer_address }}, <br />
            {{ insurance.insurer_phone }}
          </td>
        </tr>
        <tr>
          <td>1.17.</td>
          <td>
            Комиссионное вознаграждение страхового агента (наличие либо
            отсутствие)
          </td>
          <td>{{ insurance.insurer_commission }}</td>
        </tr>
        <tr>
          <td>1.18.</td>
          <td>
            Контактное лицо Страховщика (Ф.И.О., должность, адрес, телефон, иные
            данные)
          </td>
          <td>
            {{ insurance.insurer_contact_name }},
            {{ insurance.insurer_contact_address }},
            {{ insurance.insurer_contact_phone }}
          </td>
        </tr>
      </table>

      <p style="display: flex; justify-content: center">
        <strong> РАЗДЕЛ II. Общие условия Договора страхования </strong>
      </p>
      <p>
        <strong> 1. ПРЕДМЕТ ДОГОВОРА </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          1.1. Предметом настоящего договора является добровольное страхование
          гражданско-правовой ответственности перевозчиков и экспедиторов, в
          связи с чем Страхователь обязуется уплатить Страховщику страховую
          премию, а Страховщик обязуется при наступлении страхового случая
          осуществить страховую выплату Страхователю (Выгодоприобретателю) в
          пределах страховой суммы, предусмотренной настоящим Договором.
        </li>
        <li style="text-align: justify">
          1.2. Страховая сумма по Договору указана в Разделе I Договора.
        </li>
        <li style="text-align: justify">
          1.3. После осуществления страховой выплаты страховая сумма не
          уменьшается на величину осуществленной страховой выплаты.
        </li>
        <li style="text-align: justify">
          1.4. Франшиза по Договору является безусловной и указана в Разделе I
          Договора.
        </li>
        <section></section>
        <li style="text-align: justify">
          1.5. Безусловная франшиза — освобождение Страховщика от возмещения
          ущерба, не превышающего определенного размера, при этом ущерб
          возмещается за вычетом установленной суммы по каждому страховому
          случаю, если наступает несколько страховых случаев, франшиза
          вычитается по каждому из них, если же несколько убытков вызвано одним
          страховым случаем, франшиза вычитается только один раз.
        </li>
        <li style="text-align: justify">
          1.6. Страховая премия по Договору указана в Разделе I Договора.
        </li>
        <li style="text-align: justify">
          1.7. Страховая премия подлежит уплате в порядке и сроки, указанные в
          Разделе I Договора.
        </li>
        <li style="text-align: justify">
          1.8. В случае неуплаты Страхователем страховой премии (очередного
          страхового взноса) в сроки, оговоренные условиями Договора, Страховщик
          имеет право:
        </li>
        <li style="text-align: justify">
          1.8.1. расторгнуть Договор в одностороннем порядке, с даты неуплаты
          страховой премии (очередного страхового взноса);
        </li>
        <li style="text-align: justify">
          1.8.2. отказать в осуществлении страховой выплаты, если событие,
          имеющие признаки страхового случая наступило до уплаты страховой
          премии (очередного страхового взноса), внесение которой просрочено.
        </li>
        <li style="text-align: justify">
          1.8.1. расторгнуть Договор в одностороннем порядке, с даты неуплаты
          страховой премии (очередного страхового взноса);
        </li>
      </ul>
      <p>
        <strong> 2. ОБЪЕКТ СТРАХОВАНИЯ, СТРАХОВОЙ СЛУЧАЙ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          2.1. Объектом страхования гражданско-правовой ответственности
          грузоперевозчика и экспедитора является имущественный интерес
          Страхователя, связанный с его обязанностью в порядке, установленном
          законодательством и/или международными договорами и соглашениями,
          возместить потерпевшим убытки, произошедшие при осуществлении
          перевозки, и выразившийся в (в зависимости от типа перевозки):
        </li>
        <ul style="list-style-type: none">
          <li>
            а) утрате (гибели) и/или повреждении груза (багажа), принадлежащего
            грузовладельцам;
          </li>
          <li>
            б) причинении вреда жизни, здоровью или имуществу третьих лиц.
          </li>
        </ul>

        <li style="text-align: justify">
          2.2. Страховым случаем является факт наступления гражданско-правовой
          ответственности Застрахованного, связанный с возникновением
          обязанности последнего по возмещению убытков, причиненных потерпевшим
          в результате неисполнения (ненадлежащего исполнения) Страхователем
          своих договорных обязательств по договору перевозки, договору
          транспортной экспедиции, явившегося следствием:
          <ul style="list-style-type: none">
            <li>
              1) дорожно-транспортного происшествия, крушения или столкновения
              перевозочного средства;
            </li>
            <li>2) пожара;</li>
            <li>3) пропажи перевозочного средства;</li>
            <li>4) противоправных действий третьих лиц;</li>
            <li>5) кражи, грабежа, разбойного нападения;</li>
            <li>
              6) происшествий при погрузочно-разгрузочных работах, не зависящих
              от воли Страхователя и контрагентов по договору перевозки;
            </li>
            <li>7) повреждения груза в ходе его перевозки.</li>
          </ul>
        </li>

        <li style="text-align: justify">
          2.2.1. Противоправные действия третьих лиц: по указанному событию
          возмещается ущерб грузу в результате действий третьих лиц, которые
          квалифицируются в соответствии с действующим административным или
          уголовным законодательством Республики Казахстан как:
          <ul style="list-style-type: none">
            <li>1) умышленное уничтожение или повреждение имущества;</li>
            <li>2) уничтожение или повреждение имущества по неосторожности.</li>
          </ul>
          Не является страховым риском, страховым случаем и не возмещается
          ущерб, возникший в результате:
          <ul style="list-style-type: none">
            <li>1) недостачи или исчезновения груза;</li>
            <li>
              2) изменения температуры (температурного режима), перебоев в
              подаче электроэнергии, воды, газа и тепла по любой причине;
            </li>
            <li>3) заражения, загрязнения или коррозии.</li>
          </ul>
        </li>

        <li style="text-align: justify">
          2.2.2. Кража, грабеж, разбойное нападение:
          <ul style="list-style-type: none">
            <li>
              1) по указанному риску возмещается ущерб, нанесенный грузу в
              результате
            </li>
            <li>а) кражи со взломом;</li>
            <li>б) грабежа;</li>
            <li>в) разбоя</li>
            <li>
              2) под кражей со взломом понимается тайное изъятие груза
              исключительно путем:
            </li>
            <li>
              а) взлома окон, с применением отмычек, поддельных ключей или иных
              технических средств;
            </li>
            Поддельными считаются ключи, изготовленные по поручению или с ведома
            лиц, не имеющих права распоряжаться подлинными ключами.
            <li>
              б) изъятия предметов из транспортных средств, куда злоумышленник
              ранее проник обычным путем, в которых тайно продолжал оставаться
              до их закрытия и при выходе из помещения использовал средства,
              указанные в подпункте (а) настоящем пункте;
            </li>
            <li>
              3) под разбоем понимается проникновение в транспортное средство и
              нападение с целью хищения чужого груза, соединенное с насилием,
              опасным для жизни или здоровья лица, подвергшегося нападению, или
              с угрозой непосредственного применения такого насилия.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          2.2.3. Экспедитор несет ответственность перед грузовладельцем за
          действия (бездействия) перевозчиков, которые являются Застрахованными
          по данному Договору, и с которым был заключен договор о перевозке
          груза в соответствие с Гражданским Кодексом Республики Казахстан.
        </li>
        <li style="text-align: justify">
          2.3. Возникновение обязанности Страхователя по возмещению убытков,
          причиненных потерпевшему в результате неисполнения (ненадлежащего
          исполнения) своих обязательств по договору перевозки, договору
          транспортной экспедиции, согласно настоящему договору, признается
          страховым случаем при условии соблюдения одного из следующих пунктов:
        </li>
        <ul style="list-style-type: none">
          <li>
            а) получение Страхователем обоснованной претензии или обоснованного
            иска о возмещении вреда, при обязательном письменном согласии
            Страховщика о признании случая страховым;
          </li>
          <li>
            б) вступившего в законную силу решения суда о взыскании со
            Страхователя суммы убытков, либо определения об утверждении мирового
            соглашения, условия которого были предварительно посменно
            согласованы со Страховщиком.
          </li>
        </ul>
        <section></section>
        <li style="text-align: justify">
          2.4. Возникновение обязанности Страхователя по возмещению убытков,
          причиненных третьим лицам в результате неисполнения (ненадлежащего
          исполнения) своих договорных обязательств при отсутствии условий,
          перечисленных в пунктах 2.1. - 2.2. настоящего договора не признается
          в соответствии с настоящим договором страховым случаем.
        </li>
        <li style="text-align: justify">
          2.5. Причины возникновения вреда не должны носить преднамеренный
          характер.
        </li>
      </ul>
      <p>
        <strong>
          3. ИСКЛЮЧЕНИЯ ИЗ СТРАХОВЫХ СЛУЧАЕВ И ОГРАНИЧЕНИЕ СТРАХОВАНИЯ
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          3.1. Не является страховым случаем наступление гражданско-правовой
          ответственности за причинение вреда имуществу, жизни и здоровья
          потерпевших вследствие:
          <ol style="list-style-type: none">
            <li>
              1) войны; вторжения; враждебных действий иностранного государства;
              военных или подобных им операций (независимо от того объявлена
              война или нет) или гражданской войны;
            </li>
            <li>
              2) мятежа; забастовки; локаутов; гражданских беспорядков,
              приобретающих размеры или разрастающихся до народного восстания;
              бунта; гражданских волнений; военного мятежа; революции; военного
              захвата или узурпации власти; конфискации; реквизиции или
              национализации имущества; актов терроризма;
            </li>
            <li>
              3) радиоактивного излучения или загрязнения радиоактивным топливом
              или радиоактивными отходами от сжигания атомного топлива;
            </li>
            <li>
              4) умышленных действий Страхователя
              (Застрахованного/Выгодоприобретателя) или иных заинтересованных
              лиц, либо их работников;
            </li>
            <li>
              5) невозможности осуществить перевозку груза вследствие
              неплатежеспособности, отсутствия либо поломки транспортного
              средства, как до, так и в период перевозки, невозможности
              водителем перевозчика управлять транспортным средством по причине
              болезни, совершения административного проступка. Кроме случаев,
              когда водитель докажет, что острое заболевание наступило в момент
              управления транспортным средством;
            </li>
            <li>
              6) совершения Страхователем (Застрахованным/Выгодоприобретателем),
              а равно и их работниками преступления, находящегося в прямой
              причинной связи со страховым случаем;
            </li>
            <li>
              7) действий (бездействия) Страхователя
              (Застрахованного/Выгодоприобретателя) а равно и их работников в
              состоянии алкогольного, токсического или наркотического опьянения,
              а также в состоянии, в котором он не мог понимать значение своих
              действий или руководить ими (например, состояние аффекта,
              состояние острой физической боли и т.д.);
            </li>
            <li>
              8) нарушений со стороны отправителя, или получателя перевозимого
              имущества, или других лиц, действующих от их имени, не являющихся
              стороной по настоящему договору и не указанных в числе
              Застрахованных;
            </li>
            <li>
              9) недостаточной или неправильной погрузки/упаковки либо
              несоответствующего крепления груза или маркировки перевозимого
              имущества;
            </li>
            <li>
              10) недостачи и повреждения груза при целостности наружной
              упаковки и ненарушенных пломбах грузоотправителя или таможенных
              органов, или вследствие неправильной укладки / размещения в
              транспортное средство, а также ненадлежащего крепления,
              застрахованного груза;
            </li>
            <li>
              11) перегрузки, погрузки, укладки или разгрузки перевозимого
              имущества, выполненными отправителем, или получателем, или любым
              другим лицом, действующим от их имени, не являющихся стороной по
              настоящему договору и не указанных в числе Застрахованных;
            </li>
            <li>
              12) изъятие перевозимого имущества либо груза таможенными
              органами;
            </li>
            <li>
              13) дефекта, присущего перевозимому имуществу, или естественных
              свойств перевозимого имущества;
            </li>
            <li>
              14) известной Страхователю до выхода в рейс неспособности
              перевозочного средства совершить рейс и (или) непригодности
              перевозочного средства к осуществлению перевозки, осуществляемой
              на основании договора перевозки;
            </li>
            <li>
              15) участия Страхователя в контрабандных или иных незаконных
              операциях;
            </li>
            <li>
              16) нарушения норм и несоблюдения техники безопасности на
              транспорте, осуществляющем перевозку грузов;
            </li>
            <li>
              17) нарушении технологии погрузки/разгрузки груза либо
              использования для этого средств, не обеспечивающих безопасность
              проводимых операций;
            </li>
            <li>
              18) повреждения грузов без упаковки либо перевозимых связками, на
              паллетах под полиэтиленовой пленкой без индивидуальной тары или не
              в заводской упаковке (при условии, что груз не был закреплен
              стяжными ремнями, цепями либо иными способами, в полной мере
              обеспечивающими надлежащее крепление перевозимого груза);
            </li>
            <li>
              19) возврата груза в место отправления или направления груза в
              место назначения, не обусловленное в Декларации по причине
              обстоятельств, зависящих от Страхователя/Выгодоприобретателя,
              перевозчика, экспедитора и/или отправителя, включая
              безосновательное изменение маршрута следования;
            </li>
            <li>
              20) необеспечения сохранности застрахованного имущества, а именно:
              оставления имущества без надлежащей охраны, не приведения в
              рабочее положение запорных устройств и/или приспособлений, а равно
              отсутствия таковых, отсутствие иных мер безопасности, а равно не
              приведения их в рабочее положение;
            </li>
            <li>
              21) эксплуатации транспортного средства с отклонениями от
              требований регламента технического обслуживания или правил
              эксплуатации, или эксплуатации транспортного средства с
              просроченными ресурсами (последнее - для авиа и морского
              перевозчика);
            </li>
            <li>
              22) эксплуатации транспортного средства, не прошедшего технический
              осмотр или находящегося в неисправном состоянии;
            </li>
            <li>23) отправления груза в поврежденном состоянии;</li>
            <li>24) падения цен на перевозимый груз;</li>
            <li>
              25) причинения вреда при перевозке, не оформленной и не
              подтвержденной соответствующими документами;
            </li>
            <li>
              26) причинения вреда при перевозке следующих грузов:
              <ul style="list-style-type: none">
                <li>а) слитков драгоценных металлов и изделий из них;</li>
                <li>б) драгоценных камней и ювелирных изделий;</li>
                <li>
                  в) банкнот, монет, дорожных и банковских чеков, облигаций,
                  платежных средств и ценных бумаг иного рода;
                </li>
                <li>г) произведений искусства;</li>
              </ul>
            </li>

            <li style="list-style-type: none">
              27) причинения вреда, прямо или косвенного связанного с:
              <ul style="list-style-type: none">
                <li>
                  а) шумом (воспринимаемого или не воспринимаемого человеческим
                  ухом), вибрацией, звуковым ударом или другими явлениями
                  сходной природы;
                </li>
                <li>б) электрическими или электромагнитными помехами;</li>
              </ul>
            </li>
          </ol>
        </li>

        <li style="text-align: justify">
          3.2. Под убытками в соответствии с настоящим договором подразумеваются
          расходы, которые произведены или должны быть произведены потерпевшим,
          утрата или повреждение имущества (реальный ущерб).
        </li>
        <li style="text-align: justify">
          3.3. Страховая защита распространяется исключительно на
          ответ¬ственность за реальный ущерб.
        </li>
        <li style="text-align: justify">
          3.4. Страховщик не производит страховую выплату за:
          <ul style="list-style-type: none">
            <li>
              1) косвенные коммерческие потери Страхователя или потерпевшего,
              потери (штрафы, неустойка
            </li>
            <li>
              2) убытки в виде упущенной выгоды, то есть неполученные доходы,
              которые потерпевший получил бы при обычных условиях оборота, если
              бы его право не было нарушено;
            </li>
            <li>3) моральный вред;</li>
            <li>
              4) судебные и экспертные издержки, за исключением, если расходы на
              эти издержки были в целях предотвращения или уменьшения убытков,
              подлежащих возмещению Страховщиком.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          3.5. Страховщик не несет ответственность за убытки, связанные с
          нарушением грузоотправителем своих обязанностей по предоставлению
          информации в отношении перевозимого груза, а именно: не предоставление
          информации о свойствах груза, условиях его перевозки, а также иной
          информации, необходимой для исполнения перевозчиком/экспедитором
          обязанности, предусмотренной договором транспортной экспедиции.
        </li>
        <li style="text-align: justify">
          3.6. Страховщик не производит страховую выплату, если
          перевозчик/экспедитор не сообщил отправителю (получателю) груза об
          обнаруженных недостатках полученной информации, и если не запросил
          отправителя (получателя) груза необходимые дополнительные данные и не
          принял соответствующих мер по предотвращению риска.
        </li>
        <li style="text-align: justify">
          3.7. Страховая выплата не производится Страховщиком, если перевозка
          следующих грузов была произведена без наличия соответствующей лицензии
          и разрешения: - перевозка опасных грузов; - перевозка ядов, перечень
          которых установлен Постановлением Правительства РК от 16 февраля 2015
          года №59, а в случае прекращения его действия, в ином акте, содержащем
          такой перечень; - перевозка наркотических средств, прекурсоров,
          психотропных веществ.
        </li>
      </ul>
      <p>
        <strong> 4. ДВОЙНОЕ СТРАХОВАНИЕ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          4.1. Двойное страхование - страхование одного и того же объекта у
          нескольких Страховщиков по самостоятельным договорам с каждым.
        </li>
        <section></section>
        <li style="text-align: justify">
          4.2. При двойном страховании Страховщик несет перед
          выгодоприобретателем имущественную ответственность в пределах
          заключенного со Страхователем договора, однако общая сумма страховых
          выплат, полученная выгодоприобретателем за вред, причиненный его
          имуществу, от всех страховщиков, не может превышать реального ущерба.
        </li>
        <li style="text-align: justify">
          4.3. При двойном страховании после наступления страхового случая
          Страхователь обязан предоставлять Страховщику все сведения, касающиеся
          урегулирования вопроса страховой выплаты в иных страховых компаниях, в
          том числе сведения о размерах страховой выплаты, полученных от иных
          страховых компаний.
        </li>
        <li style="text-align: justify">
          4.4. При двойном страховании Страховщик вправе выяснять причины и
          обстоятельства события, имеющего признаки страхового случая,
          определять размер убытков, причиненных в результате страхового случая,
          совместно с другими страховыми компаниями.
        </li>
      </ul>
      <p>
        <strong> 5. ПРАВА И ОБЯЗАННОСТИ СТОРОН </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          5.1. Страхователь имеет право:
          <ul style="list-style-type: none">
            <li>
              1) требовать от Страховщика информацию о его платежеспособности и
              финансовой устойчивости, если не является конфиденциальной
              информацией;
            </li>
            <li>
              2) на возмещение затрат в пределах указанного в договоре
              страхования размера страховой суммы (предельного объема
              ответственности), если он по письменному согласию Страховщика сам
              урегулировал требования потерпевшего;
            </li>
            <li>
              3) совершать иные действия, предусмотренные законодательством
              Республики Казахстан.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          5.2. Страхователь обязан:
          <ul style="list-style-type: none">
            <li>1) информировать Страховщика о состоянии страхового риска;</li>
            <li>
              2) предоставлять Страховщику декларации на каждую отгрузку при
              перевозке, до фактической отправки груза. Суммированная сумма
              деклараций не должна превышать страховую сумму по договору.
              Превышение страховой суммы по договору страхования дает право
              Страховщику потребовать от Страхователя уплаты дополнительной
              страховой премии соразмерно увеличению объема перевозимых грузов.
              В случае отказа Страхователя от уплаты дополнительной страховой
              премии Страховщик вправе отказать в осуществлении страховой
              выплаты и/или расторгнуть договор страхования, при этом уплаченная
              ранее Страхователем страховая премия, возврату не подлежит;
            </li>
            <li>
              3) письменно сообщать Страховщику обо всех заключенных и
              заключаемых договорах страхования гражданско-правовой
              ответственности с другими страховыми компаниями;
            </li>
            <li>
              4) соблюдать установленные нормативными актами правила и нормы
              перевозки грузов;
            </li>
            <li>
              5) уплачивать страховую премию в размерах, порядке и сроки,
              установленные договором страхования;
            </li>
            <li>
              6) довести до сведения своих работников требования условий
              договора страхования (круг работников определяется Страхователем);
            </li>
            <li>
              7) выполнять условия договора страхования и правил страхования
              (нарушение правил страхования работниками Страхователя
              расценивается как нарушение правил страхования самим
              Страхователем);
            </li>
            <li>
              8) при наступлении события, имеющего признаки страхового случая,
              совершить необходимые действия, указанные в пункте 7.2. настоящего
              договора;
            </li>
            <li>
              9) незамедлительно, но не позднее 3 (Трех) дней (за исключением
              праздничных и выходных дней) со дня, когда ему стало известно,
              сообщить Страховщику о начале действий компетентных органов по
              факту причинения вреда (расследование, возбуждение уголовного
              дела, вызов в суд и т.п.), а также о всех предъявляемых претензий
              потерпевшего, о подаче искового заявления и т.п.;
            </li>
            <li>
              10) принимать все доступные меры по уменьшению размеров
              предъявляемых требований, если у Страхователя имеются для этого
              основания;
            </li>
            <li>
              11) сохранять конфиденциальность условий договора страхования и
              размерах страховых премий и выплат;
            </li>
            <li>
              12) обеспечить переход к Страховщику права требования к лицу,
              ответственному за наступление страхового случая.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          5.3. Страховщик имеет право:
          <ul style="list-style-type: none">
            <li>1) проверять представляемую ему информацию и документы;</li>
            <li>
              2) проверять в период действия договора страхования соблюдение
              Страхователем правил эксплуатации и технического обслуживания
              транспортных средств и перевозки грузов;
            </li>
            <li>3) участвовать в осмотре поврежденного имущества;</li>
            <li>
              4) самостоятельно выяснять причины и обстоятельства события,
              имеющего признаки страхового случая, в том числе направлять
              запросы в компетентные органы;
            </li>
            <li>
              5) требовать от Страхователя информацию, необходимую для
              установления факта страхового случая, обстоятельств его
              возникновения;
            </li>
            <li>
              6) участвовать в суде в качестве третьего лица, не заявляющего
              самостоятельные требования;
            </li>
            <li>
              7) в установленном законом порядке оспорить размер требований,
              предъявляемых к Страхователю;
            </li>
            <li>
              8) отказать в страховой выплате в случае непризнания события
              страховым случаем на основании пункта 3.1. настоящего договора,
              либо в случаях, предусмотренных п.11.6. настоящего договора,
              письменно уведомив об этом Страхователя и потерпевшего;
            </li>
            <li>
              9) отказать в страховой выплате в случае несообщения Страхователем
              о наступившем страховом случае, либо событии, которое может
              повлечь наступление страхового случая, в 3-х дневный срок (за
              исключением праздничных и выходных дней) либо препятствования
              осмотру потерпевшего имущества;
            </li>
            <li>
              10) отказать в страховой выплате в случае обнаружения превышения
              фактического объема перевозок над заявленным объемом перевозок;
            </li>
            <li>
              11) в случае увеличения степени риска потребовать изменения
              условий договора страхования или уплаты дополнительной страховой
              премии соразмерно увеличению риска;
            </li>
            <li>
              12) совершать иные действия, предусмотренные законодательством
              Республики Казахстан.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          5.4. Страховщик обязан:
          <ul style="list-style-type: none">
            <li>1) ознакомить Страхователя с условиями страхования;</li>
            <li>
              2) сообщать перечень документов, необходимых к представлению для
              принятия решения о признании события страховым случаем и
              осуществления страховой выплаты;
            </li>
            <li>
              3) принять решение о признании или непризнании события страховым
              случаем в срок, установленный п.11.1. настоящего договора;
            </li>
            <li>
              4) при наступлении страхового случая произвести страховую выплату
              в размере, порядке и сроки, установленные п. 11.1. настоящего
              договора;
            </li>
            <li>
              5) возместить Страхователю расходы, произведенные им для
              уменьшения убытков при страховом случае;
            </li>
            <li>
              6) письменно уведомить Страхователя и потерпевшего о непризнании
              события страховым случаем или о принятии решения уменьшить размер
              страховой выплаты;
            </li>
            <li>7) обеспечить тайну страхования.</li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>
          6. ПОСЛЕДСТВИЯ УВЕЛИЧЕНИЯ СТЕПЕНИ СТРАХОВОГО РИСКА В ПЕРИОД ДЕЙСТВИЯ
          ДОГОВОРА
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          6.1. В период действия договора страхования Страхователь обязан
          незамедлительно, но не позднее 5 (пяти) рабочих дней письменно
          сообщить Страховщику о ставших ему известными значительных изменениях
          в обстоятельствах, сообщенных Страховщику при заключении договора
          страхования, если эти изменения могут существенно повлиять на
          увеличение страхового риска.
        </li>
        <li style="text-align: justify">
          6.2. Значительными во всяком случае признаются:
          <ul style="list-style-type: none">
            <li>1) изменение территории страхования;</li>
            <li>2) изменение категории груза;</li>
            <li>3) изменение типа транспортного средства;</li>
            <li>4) увеличение объемов перевозок (страховой суммы);</li>
            <li>
              5) передача транспортного средства, в отношении которого
              осуществлялось страхование, в аренду, лизинг, прокат.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          6.3. Страховщик, уведомленный об обстоятельствах, влекущих увеличение
          страхового риска, вправе потребовать изменения условий договора
          страхования и уплаты дополнительной страховой премии соразмерно
          увеличению страхового риска.
        </li>
        <li style="text-align: justify">
          6.4. Если Страхователь возражает против изменения условий договора
          страхования или доплаты страховой премии, Страховщик вправе
          потребовать расторжения договора страхования в соответствии с
          законодательством Республики Казахстан. При этом, порядок возврата
          Страхователю страховой премии устанавливается договором страхования.
        </li>
        <li style="text-align: justify">
          6.5. При невыполнении Страхователем предусмотренной в пункте 6.1.
          настоящего договора обязанности Страховщик вправе потребовать
          расторжения договора и возмещения убытков, причиненных расторжением
          договора, или, при наступлении страхового случая, уменьшить размер
          страховой выплаты соразмерно увеличению страхового риска, либо
          отказать в страховой выплате.
        </li>
        <li style="text-align: justify">
          6.6. Страховщик не вправе требовать расторжения договора, если
          обстоятельства, влекущие увеличение страхового риска, уже отпали.
        </li>
        <section></section>
      </ul>
      <p>
        <strong>
          7. ДЕЙСТВИЯ СТРАХОВАТЕЛЯ ПРИ НАСТУПЛЕНИИ СТРАХОВОГО СЛУЧАЯ
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          7.1. Доказывание наступления страхового случая, а также причинных им
          убытков лежит на Страхователе (Выгодоприобретателе).
        </li>
        <li style="text-align: justify">
          7.2. При наступлении события, имеющего признаки страхового случая
          и/или последствием которого может быть наступление страхового случая,
          в том числе при предъявлении претензий (иска) со стороны потерпевшего,
          Страхователь обязан:
          <ul style="list-style-type: none">
            <li>
              1) незамедлительно принять разумные и доступные в сложившейся
              ситуации меры к уменьшению убытков, связанных с событием, которое
              может послужить поводом для предъявления претензий;
            </li>
            <li>
              2) обеспечить документальное оформление события в соответствующих
              государственных либо ведомственных органах;
            </li>
            <li>
              3) в течение 3 (трех) дней (за исключением праздничных и выходных
              дней), считая с того часа, когда он узнал, письменно уведомить
              Страховщика или его полномочного представителя о наступлении
              события, имеющего признаки страхового случая и/или последствием
              которого может быть наступление страхового случая (о претензиях
              потерпевшего, о вызове в суд, исковом заявлении) и обеспечить
              Страховщика всей необходимой информацией и документацией
              относительно всех обстоятельств дела, в частности, информацией,
              документами, полученными в связи с данным событием, включая,
              имена, наименования и адреса всех лиц, вовлеченных в событие, в
              том числе истцов;
            </li>
            <li>
              4) при получении Страхователем от потерпевшего претензий о
              возмещении убытков, причиненных Страхователем в результате
              неисполнения (ненадлежащего исполнения) своих договорных
              обязательств составить заключение об обоснованности или
              необоснованности претензии, и представить претензию потерпевшего,
              заключение и подтверждающие документы Страховщику;
            </li>
            <li>
              5) в случае признания Страховщиком претензии необоснованной при
              участии Страховщика подготовить и направить потерпевшему
              возражение на претензию;
            </li>
            <li>
              6) при судебном урегулировании спора не препятствовать праву
              Страховщика вступить в дело в качестве третьего лица, не
              заявляющего самостоятельные требования до вынесения судом решения,
              а также ходатайствовать перед судом о привлечении Страховщика в
              судебное дело в качестве «третьего лица, не заявляющего
              самостоятельные требования»;
            </li>
            <li>
              7) до и в ходе судебного разбирательства не совершать каких-либо
              действий, не делать заявлений по существу рассматриваемого дела в
              отношении объекта страхования без предварительного согласования со
              Страховщиком;
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          7.3. Неуведомление Страховщика о наступлении страхового случая дает
          ему право отказать в страховой выплате, если не будет доказано, что
          Страховщик своевременно узнал о наступлении страхового случая либо
          отсутствие у Страховщика сведений об этом не могло сказаться на его
          обязанности осуществить страховую выплату, а также при наличии
          уважительных причин и представления соответствующих документов.
        </li>
        <li style="text-align: justify">
          7.4. Страхователь обязан предоставлять Страховщику по его запросу
          сведения, связанные со страховым случаем, включая сведения,
          составляющие коммерческую тайну.
        </li>
        <li style="text-align: justify">
          7.5. Страхователь обязан не совершать действий, направленных против
          интересов Страховщика, а также не принимать каких-либо обязательств,
          не признавать ответственность, не принимать какие бы то ни было
          предложения, не делать выплат и не обещать сделать какие-либо выплаты,
          имеющие отношение к данному страховому случаю, без письменного
          согласия Страховщика.
        </li>
        <li style="text-align: justify">
          7.6. Страхователь обязан предоставить Страховщику (по требованию
          последнего) полномочия Страхователя при урегулировании претензий в
          досудебном и судебном порядке.
        </li>
        <li style="text-align: justify">
          7.7. Страховщик имеет право взять на себя защиту прав Страхователя и
          вести все дела по урегулированию спора в отношении претензий
          потерпевшего по поводу неисполнения (ненадлежащего исполнения)
          обязательств по договору, а также выступать в суде от имени
          Страхователя.
        </li>
      </ul>
      <p>
        <strong>
          8. ПЕРЕЧЕНЬ ДОКУМЕНТОВ, ПОДТВЕРЖДАЮЩИХ НАСТУПЛЕНИЕ СТРАХОВОГО СЛУЧАЯ И
          РАЗМЕР УБЫТКОВ
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          8.1. Требование о страховой выплате к Страховщику предоставляется
          Страхователем либо потерпевшим в письменной форме с приложением
          документов, обосновывающих соответствующее требование.
        </li>
        <li style="text-align: justify">
          8.2. К заявлению о страховой выплате прилагаются следующие документы:
          При причинении вреда имуществу потерпевших, багажу, грузу:
          <ul style="list-style-type: none">
            <li>1) договор страхования;</li>
            <li>
              2) доверенность на право ведения дел в страховой компании (для
              юридического лица, либо представлении интересов потерпевших) -
              оригинал;
            </li>
            <li>
              3) свидетельство о регистрации транспортного средства,
              осуществлявшего перевозку;
            </li>
            <li>
              4) полученные претензии от третьих лиц по событию, имеющего
              признаки страхового случая, письменная претензия (исковое
              заявление) к Страхователю потерпевшего или их правопреемников, с
              приложением заключения Страхователя об обоснованности либо
              необоснованности претензии и документов, подтверждающих
              наступление страхового случая, предусмотренного договором
              страхования
            </li>
            <li>
              5) товарно-транспортные накладные или другие транспортные
              документы с отметками грузополучателя, или его представителя о
              недостаче или повреждении груза; - счета-фактуры и счета на
              оплату; - упаковочные ведомости; - акты осмотра груза (аварийные
              сертификаты), акты экспертизы, составляемые независимыми
              специализированными организациями согласно законодательству или
              деловым обычаям страны места происшествия или освидетельствования
              груза на предмет определения недостачи или оценки его повреждений;
              - расчет убытка с приложением подтверждающих документов,
              заявляемого перевозчику/экспедитору стороной, требующей возмещения
              убытков;
            </li>
            <li>
              6) комплект документов, получение и предоставление которых
              является в зависимости от вида происшествия: -протокол дорожной
              полиции (линейного отдела внутренних дел) в случае
              дорожно-транспортного происшествия; -справку правоохранительных
              органов, подтверждающую факт обращения в эти органы
              перевозчика/экспедитора по случаю кражи груза или других
              происшествий криминального характера во время перевозки груза или
              справку-подтверждение правоохранительных органов о возбуждении
              уголовного дела по факту кражи или другого криминального
              происшествия; -письменное объяснение водителя о происшествии; -
              подтверждающие документы на расходы, произведенные Страхователем в
              целях предотвращения или уменьшения убытков; - копия переписки с
              заявителями претензии;
            </li>
            <li>
              7) копии документов следственных и судебных органов (если таковые
              имеются) по факту наступления страхового случая, решение судебных
              органов (или его копию) о взыскании со Страхователя суммы убытков,
              причиненных в результате неисполнения (ненадлежащего исполнения)
              обязательств по договору, в пользу потерпевшего.
            </li>
            <li>
              8) оригинал доверенности, выданная отправителем (получателем)
              груза перевозчик/экспедитору, если таковая необходима для
              выполнения его обязанностей;
            </li>
            <li>
              9) и другие документы, подтверждающие наступление страхового
              случая.
            </li>
          </ul>

          В случае прибытия в пункт назначения позже установленной даты:

          <ul style="list-style-type: none">
            <li>
              1) копия международной товарно-транспортной накладной (CMR –
              накладная) с оговоркой об опоздании и фактическая дата и время
              прибытия в пункт назначения.
            </li>
            <li>
              В случае причинения вреда жизни и/или здоровью потерпевших,
              предоставляются следующие документы:
            </li>
            <li>
              1) справки медицинских учреждений о сроке временной
              нетрудоспособности или справка специализированных учреждений об
              установлении инвалидности в случае ее возникновения для
              потерпевших третьих лиц;
            </li>
            <li>
              2) копия свидетельства о смерти (для погибших третьих лиц в
              последствии наступления страхового случая или умерших вследствие
              этого страхового случая);
            </li>
            <li>
              3) копии документов следственных и судебных органов (если таковые
              имеются) по факту наступления страхового случая.
            </li>
          </ul>
        </li>

        <li style="text-align: justify">
          8.3. Документы, указанные в пункте 8.2. предоставляются в оригинале
          или копии с предоставлением Страховщику оригиналов документов для
          осуществления сверки, если пунктом 8.2. прямо не установлено
          обязательство о предоставлении оригинала документа.
        </li>
        <li style="text-align: justify">
          8.4. Страховщик, принявший документы, обязан составить в двух
          экземплярах справку с указанием полного перечня представленных
          заявителем документов и даты их принятия. Один экземпляр справки
          выдается заявителю, второй экземпляр с отметкой заявителя в ее
          получении остается у Страховщика.
        </li>
        <li style="text-align: justify">
          8.5. В случае не предоставления Страхователем всех документов,
          предусмотренных пунктом 8.2. настоящего договора страхования,
          Страховщик обязан с момента предоставления не полного пакета
          документов, в течение 30 (тридцати) рабочих дней письменно уведомить
          Страхователя о недостающих документах, необходимых для осуществления
          страховой выплаты.
        </li>
      </ul>
      <p>
        <strong> 9. ПОРЯДОК И УСЛОВИЯ ОСУЩЕСТВЛЕНИЯ СТРАХОВЫХ ВЫПЛАТ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          9.1. После получения от Страхователя письменного уведомления о
          наступлении страхового случая Страховщик в сроки, указанные в разделе
          11 настоящего договора после предоставления документов, подтверждающих
          наступление страхового случая, указанных в разделе 8 настоящего
          договора осуществляет следующие действия:
          <ul style="list-style-type: none">
            <li>
              1) устанавливает факт наступления события, имеющего признаки
              страхового случая; проверяет соответствие приведенных в заявлении
              Страхователя сведений; определяет факт и причины возникновения
              события, вследствие которого были причинены убытки; определяет
              необходимость привлечения экспертов, аварийных комиссаров,
              осуществляет иные действия;
            </li>
            <li>
              2) при предоставлении Страхователем претензии, заключения
              Страхователя об обоснованности претензии и документов,
              подтверждающих обоснованность претензии потерпевшего, - проводит
              исследование претензии и документов;
            </li>
            <li>
              3) в случае признания претензии необоснованной оказывает
              содействие Страхователю в подготовке возражения на претензию
              потерпевшего;
            </li>
            <li>
              4) в случае судебного разбирательства принимает участие в суде в
              качестве третьего лица, не заявляющего самостоятельного
              требования, либо в качестве представителя Страхователя;
            </li>
            <li>
              5) при признании события страховым случаем определяет размер
              страховой выплаты, составляет акт о страховом случае.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          9.2. Страховая выплата производится Страховщиком на основании
          письменного заявления Страхователя о выплате и акта о страховом
          случае. Выплаты, произведенные Страхователем в счет будущих страховых
          выплат без письменного согласия Страховщика, во внимание не
          принимаются.
        </li>
        <li style="text-align: justify">
          9.3. Акт о страховом случае составляется Страховщиком или
          уполномоченным им лицом
        </li>
      </ul>

      <p>
        <strong>
          10. ОПРЕДЕЛЕНИЕ РАЗМЕРА УБЫТКОВ И РАЗМЕРА СТРАХОВОЙ ВЫПЛАТЫ
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          10.1. Страховая выплата по страховому риску «причинение вреда жизни и
          здоровью потерпевшего» производится потерпевшему, а в случае смерти —
          его наследникам.
        </li>
        <li style="text-align: justify">
          10.2. Размер страховой выплаты по риску причинение вреда жизни и
          здоровью третьих лиц на одного потерпевшего составляет (в МРП):
        </li>
        <ul style="list-style-type: none">
          <li>
            • за вред, причиненный жизни и здоровью каждого потерпевшего и
            повлекший:
          </li>
        </ul>
        <li>- гибель – 1 000</li>
        <li>- установление инвалидности:</li>
        <ul style="list-style-type: none">
          <li>I группа – 800</li>
          <li>II группа – 600</li>
          <li>II группа – 400</li>
        </ul>

        <li>
          - увечье, травму или повреждение здоровья без установления
          инвалидности – в размере фактических расходов на амбулаторное и/или
          стационарное лечение, но не более 200. При этом размер страховой
          выплаты за каждый день стационарного лечения должен составлять не
          менее 1,5 МРП.
        </li>
        <li style="text-align: justify">
          10.3. Размер страховой выплаты по риску «причинение вреда имуществу
          потерпевших» - в размере причиненного вреда каждому потерпевшему. Для
          расчета размера страховой выплаты используется МРП, установленный в
          соответствии с законодательным актом Республики Казахстан на день
          страховой выплаты.
        </li>
        <li style="text-align: justify">
          10.4. Страховая выплата за ущерб (убыток), причиненный грузу
          оценивается Страховщиком или назначенным им независимым оценщиком в
          размере суммы затрат на восстановление груза в случае его повреждения
          либо в размере стоимости груза, в случае полной гибели (утери), в
          соответствии с товаротранспортными документами, с учетом стоимости
          остатков, годных для дальнейшего использования или реализации, а также
          амортизационного износа груза, бывшего в употреблении.
        </li>
        <li style="text-align: justify">
          10.5. Страховщик осуществляет страховую выплату не более размера
          реального ущерба. В размер страховой выплаты не включается неустойка,
          пени и другие штрафные санкции.
        </li>
        <li style="text-align: justify">
          10.6. При утрате, недостаче и/или повреждении (порче) сданного к
          перевозке груза или имущества третьих лиц, произошедших по вине
          Перевозчика/экспедитора, размер причиненного вреда определяется
          следующим образом:
          <ul style="list-style-type: none">
            <li>
              1) в случае повреждения (порчи) груза или имущества третьих лиц –
              в размере суммы, на которую понизилась его стоимость, при
              невозможности восстановления груза или имущества третьих лиц – в
              размере их стоимости;
            </li>
            <li>
              2) в случае утраты груза или имущества третьих лиц, сданного к
              перевозке и объявлением его ценности, - в размере его объявленной
              стоимости.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          10.7. В случае несогласия с результатами оценки размера вреда,
          причиненного имуществу, произведенной независимым экспертом,
          Страхователь или потерпевший вправе обратиться к другому независимому
          эксперту для оценки размера вреда.
        </li>
        <li style="text-align: justify">
          10.8. Если Страховщиком или независимым экспертом в течение 15
          (пятнадцати) рабочих дней со дня получения им сообщения о наступлении
          страхового случая не были произведены необходимый осмотр недостающего
          или поврежденного (испорченного) имущества и оценка размера вреда,
          причиненного имуществу, с составлением страхового акта, то
          Страхователь или потерпевший вправе самостоятельно организовать оценку
          ущерба оценщиком, имеющим соответствующую лицензию, и начать
          восстановление (утилизацию) имущества. При этом Страховщик не вправе
          оспорить результаты оценки размера вреда, причиненного имуществу, если
          не доказано, что невозможность своевременной оценки им поврежденного
          (уничтоженного) имущества обусловлена уважительными причинами (смерть
          или болезнь владельца данного имущества) либо наличием вины
          Страхователя или потерпевшего, связанной с уклонением от
          предоставления имущества для оценки.
        </li>
        <li style="text-align: justify">
          10.9. Общий размер страховой выплаты, осуществляемой Страховщиком, за
          вред, причиненный жизни, здоровью и имуществу всех потерпевших,
          ограничивается размером страховой суммы, определяемой договором
          страхования для одного страхового случая.
        </li>
        <li style="text-align: justify">
          10.10. Расходы, понесенные Страхователем в целях предотвращения или
          уменьшения убытков, подлежат возмещению Страховщиком, если такие
          расходы были необходимы или были произведены для выполнения указаний
          Страховщика, даже если соответствующие меры оказались безуспешными.
        </li>
        <li style="text-align: justify">
          10.11. Указанные в <strong>п.10.6.</strong> расходы возмещаются в
          фактических размерах, однако с тем, чтобы общая сумма страховой
          выплаты и компенсации расходов не превысила страховой суммы,
          предусмотренной договором страхования для риска причинения вреда
          имуществу потерпевшего. Если расходы возникли в результате исполнения
          Страхователем указаний Страховщика, они возмещаются в полном размере,
          безотносительно к страховой сумме.
        </li>
        <li style="text-align: justify">
          10.12. Страховщик освобождается от осуществления страховой выплаты в
          части тех убытков, которые возникли вследствие того, что Страхователь
          умышленно не принял разумных и доступных ему мер, чтобы уменьшить
          возможные убытки.
        </li>
      </ul>
      <p>
        <strong>
          11. СРОК ПРИНЯТИЯ РЕШЕНИЯ О СТРАХОВОЙ ВЫПЛАТЕ ИЛИ ОТКАЗЕ В СТРАХОВОЙ
          ВЫПЛАТЕ
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          11.1. Страховщик, после получения всех необходимых документов для
          принятия решения, в десятидневный срок либо в срок, определенный
          соглашением сторон, принимает решение о страховой выплате или об
          отказе в страховой выплате. Если Страховщиком принято решение об
          отказе в страховой выплате, он сообщает об этом Страхователю
          (выгодоприобретателю) в письменной форме обоснованно мотивируя причину
          отказа.
        </li>
        <li style="text-align: justify">
          11.2. Страховщик осуществляет страховую выплату Выгодоприобретателю в
          течение 10 (десяти) рабочих дней после принятия решения о страховой
          выплате, либо в срок, определенный соглашением сторон.
        </li>
        <li style="text-align: justify">
          11.3. Если по письменному согласию Страховщика Страхователь сам
          компенсировал убытки потерпевшему, страховая выплата осуществляется
          Страхователю в течение 10 (десяти) рабочих дней, со дня принятия
          решения о страховой выплате, либо в срок, определенный соглашением
          сторон, и после получения оформленной надлежащим образом расписки
          потерпевшего или другого документа, свидетельствующего о компенсации
          убытка и отказе от претензий к Страхователю.
        </li>
        <li style="text-align: justify">
          11.4. За несвоевременное осуществление страховой выплаты Страховщик
          несет ответственность в соответствии со статьей 353 Гражданского
          кодекса Республики Казахстан.
        </li>
        <li style="text-align: justify">
          11.5. Отказ Страховщика произвести страховую выплату может быть
          обжалован Страхователем или выгодоприобретателем в суд по подсудности
          фактического места расположения Головного офиса Страховщика или
          Специализированный Межрайонный Экономический суд города Алматы (если
          Страхователь юридическое лицо или индивидуальный предприниматель),
          после направления претензии в адрес Страховщика.
        </li>
        <li style="text-align: justify">
          11.6. Основанием для отказа Страховщика в осуществлении страховой
          выплаты может быть следующее:
          <ul style="list-style-type: none">
            <li>
              1) сообщение Страхователем Страховщику заведомо ложных сведений об
              объекте страхования, страховом риске, страховом случае и его
              последствиях;
            </li>
            <li>
              2) умышленное непринятие Страхователем мер по уменьшению убытков
              от страхового случая;
            </li>
            <li>
              3) воспрепятствование Страхователем Страховщику в расследовании
              обстоятельств наступления страхового случая и в установлении
              размера причиненного им убытка;
            </li>
            <li>
              4) отказ Страхователя от своего права требования к лицу,
              ответственному за наступление страхового случая, а также отказ
              передать Страховщику документы, необходимые для перехода к
              Страхователю права требования;
            </li>
            <li>
              5) нарушение Страхователем положений правил или договора
              страхования.
            </li>
          </ul>
        </li>
        <li style="text-align: justify">
          11.7. Страховщик имеет право отсрочить принятие решения о страховой
          выплате в случае, если у него имеются сомнения в подлинности
          документов, подтверждающих страховой случай или размер убытков
          (нечеткая подпись либо печать на документе, несовпадение подписи на
          документе и в удостоверении личности, фотография с признаками
          подделки), с письменным уведомлением Страхователя в течение 7 (семь)
          рабочих дней после получения документов, согласно разделу 8 настоящего
          договора до тех пор, пока не будет подтверждена подлинность таких
          документов, либо при наличии судебного разбирательства, затрагивающего
          интересы Страховщика. При этом Страховщик обязан подать документы в
          орган выдавший документ, для подтверждения его подлинности.
        </li>
      </ul>
      <p>
        <strong> 12. СУБРОГАЦИЯ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          12.1. К Страховщику, осуществившему страховую выплату, переходит в
          пределах уплаченной суммы право требования, которое Страхователь имеет
          к лицу, ответственному за убытки, возмещенные в результате страхования
          (суброгация).
        </li>
        <li style="text-align: justify">
          12.2. Страхователь обязан при получении страховой выплаты передать
          Страховщику все имеющиеся у него документы и доказательства, и
          сообщить ему все сведения, необходимые для осуществления Страховщиком
          перешедшего к нему права требования.
        </li>
        <li style="text-align: justify">
          12.3. Если Страхователь отказался от своего права требования к лицу,
          ответственному за убытки, возмещенные Страховщиком, или осуществление
          этого права стало невозможным по вине Страхователя, Страховщик
          освобождается от осуществления страховой выплаты полностью или в
          соответствующей части и в праве потребовать возврата излишне
          уплаченной суммы.
        </li>
      </ul>

      <p>
        <strong> 13. УСЛОВИЯ ПРЕКРАЩЕНИЯ ДОГОВОРА СТРАХОВАНИЯ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          13.1. Помимо общих оснований прекращения обязательств, предусмотренных
          Гражданским Кодексом Республики Казахстан договор страхования,
          прекращается досрочно в случаях:
          <ul style="list-style-type: none">
            <li>1) когда перестал существовать объект страхования;</li>
            <li>
              2) возможность наступления страхового случая отпала, и
              существование страхового риска прекратилось по обстоятельствам
              иным, чем страховой случай.
            </li>
            <li>
              3) вступления в законную силу решения суда о принудительной
              ликвидации Страховщика.
            </li>
            <li>
              4) вступления в силу решения уполномоченного органа о выдаче
              разрешения на добровольную ликвидацию Страховщика.
            </li>
          </ul>
        </li>

        <li style="text-align: justify">
          В указанных случаях договор страхования считается прекращенным с
          момента возникновения обстоятельства, предусмотренного в качестве
          основания для прекращения договора, о чем заинтересованная сторона
          должна незамедлительно уведомить другую, при этом Страховщик имеет
          право на часть страховой премии, пропорционально времени, в течение
          которого действовало страхование.
        </li>
        <li style="text-align: justify">
          13.2. Стороны имеют право на досрочное расторжение договора
          страхования, о намерении досрочного прекращения действия договора
          страхования, стороны обязаны уведомить друг друга не менее чем за 30
          календарных дней до предполагаемой даты прекращения договора
          страхования.
        </li>
        <li style="text-align: justify">
          13.3. При отказе Страхователя от договора страхования, если это не
          связано с обстоятельствами, указанными в пункте 1 статьи 841
          Гражданского кодекса Республики Казахстан, уплаченная Страховщику
          страховая премия либо страховые взносы, не подлежат возврату.
        </li>
        <li style="text-align: justify">
          13.4. В случаях, когда досрочное прекращение договора страхования
          вызвано невыполнением его условий по вине Страховщика, последний
          обязан возвратить Страхователю уплаченную им страховую премию либо
          страховые взносы полностью.
        </li>
        <li style="text-align: justify">
          13.5. Во всех случаях досрочного расторжения Договора никакая часть
          страховой премии возврату не подлежит, если по договору производились
          страховые выплаты.
        </li>
      </ul>
      <p>
        <strong> 14. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          14.1. Споры, вытекающие из договора страхования, рассматриваются
          непосредственно сторонами путем переговоров.
        </li>
        <li style="text-align: justify">
          14.2. Стороны настоящего договора при не разрешении спора путем
          переговоров до обращения в судебные органы обязаны направить другой
          стороне письменную претензию с обоснованием причин возникшего
          разногласия.
        </li>
        <li style="text-align: justify">
          14.3. Претензия подлежит рассмотрению в двухнедельный срок.
        </li>
        <li style="text-align: justify">
          14.4. В случае если претензия была отклонена полностью или частично,
          либо ответ на претензию не получен по истечении срока, указанного в
          пункте 14.3. настоящего договора, сторона имеет право обратиться в суд
          по подсудности фактического места расположения головного офиса
          Страховщика или Специализированный Межрайонный Экономический суд
          города Алматы (если Страхователь юридическое лицо или индивидуальный
          предприниматель), в соответствии с законодательством Республики
          Казахстан.
        </li>
      </ul>
      <p>
        <strong>
          15. ПОРЯДОК ВНЕСЕНИЯ ИЗМЕНЕИЙ И ДОПОЛНЕНИЙ В УСЛОВИЯ ДОГОВОРА
        </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          15.1. Внесение изменений и дополнений в договор страхования
          производится по обоюдному согласию сторон, на основании письменного
          заявления (уведомления) одной из сторон.
        </li>
        <li style="text-align: justify">
          15.2. С момента получения заявления одной из сторон до момента
          принятия решения, договор действует на прежних условиях.
        </li>
        <li style="text-align: justify">
          15.3. Изменения и дополнения к договору оформляются путем составления
          и подписания дополнительного соглашения к договору страхования.
        </li>
      </ul>
      <p>
        <strong> 16. ПРОЧИЕ УСЛОВИЯ </strong>
      </p>
      <ul style="list-style-type: none">
        <li style="text-align: justify">
          16.1. Стороны не должны разглашать информацию, полученную в результате
          заключения настоящего договора.
        </li>
        <li style="text-align: justify">
          16.2. По всем иным вопросам, не урегулированным настоящим договором,
          стороны обязуются руководствоваться правилами добровольного
          страхования гражданско-правовой ответственности перевозчиков и
          экспедиторов Акционерное общество «Дочерняя организация Народного
          Банка Казахстана «Страховая компания «Халык» и действующим
          законодательством Республики Казахстан.
        </li>
        <li style="text-align: justify">
          16.3. Настоящий договор составлен в двух экземплярах, имеющих
          одинаковую юридическую силу, по одному для каждой из Сторон.
        </li>
      </ul>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/ru";
var QRCode = require("qrcode");
export default {
  name: "liability-insurance",
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      insurance: {},
      insurer: {},
    };
  },
  mounted() {
    axios
      .get(
        window.base +
          "/Document/LoadLiabilityInsurance/?doc_id=" +
          this.doc.DocumentID,
      )
      .then((response) => {
        this.insurance = response.data;
        axios
          .get(
            window.base +
              "/Document/GetInsurerByDoc/?document_id=" +
              this.doc.DocumentID,
          )
          .then((res) => {
            this.insurer = res.data;
            axios
              .get(
                window.base + "/document/LoadSignature?doc_id=" + this.doc_id,
              )
              .then((response) => {
                if (typeof response.data.signature !== "undefined") {
                  // console.log("as")
                  if (response.data.signature == "") {
                    this.$root.$emit("print-pdf", {
                      signature: "",
                      type: "liability-insurance",
                    });
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$t("message.contracts.no-signature-message"),
                      timeout: 5000,
                    }).show();
                  } else {
                    var canvas = QRCode.toCanvas(response.data.signature, {
                      width: 100,
                      height: 100,
                    });
                    canvas.then((r) => {
                      // this.check_signature(value, ()=>{
                      this.$root.$emit("print-pdf", {
                        signature: r,
                        type: "liability-insurance",
                      });
                      new Noty({
                        theme: "light",
                        type: "success",
                        text: this.$t(
                          "message.contracts.yes-signature-message",
                        ),
                        timeout: 5000,
                      }).show();
                      // window.webSocket.removeEventListener('message', {})
                      // })
                    });
                  }
                } else {
                  // console.log("bs")
                  this.$root.$emit("print-pdf", {
                    signature: "",
                    type: "cliability-insurancer",
                  });
                  new Noty({
                    theme: "light",
                    type: "error",
                    text: this.$t("message.contracts.no-signature-message"),
                    timeout: 5000,
                  }).show();
                }
              });
          });
      });
  },
  methods: {
    getFullSum() {
      return (
        this.insurance.cargo_insured_sum +
        this.insurance.life_insured_sum +
        this.insurance.property_insured_sum
      );
    },
    getBankData() {
      if (typeof (this.insurer.banks[0] !== "undefined"))
        return (
          this.insurer.banks[0].subj_bank +
          ", " +
          this.insurer.banks[0].subj_bank_acc_number +
          ", " +
          this.insurer.banks[0].subj_bank_address
        );
    },
    getAddress() {
      if (typeof (this.insurer.addresses[0] !== "undefined"))
        return (
          this.insurer.addresses[0].post_addr_country +
          ", " +
          this.insurer.addresses[0].post_addr_region +
          ", " +
          this.insurer.addresses[0].post_addr_city +
          ", " +
          this.insurer.addresses[0].post_addr_streethouse +
          ", " +
          this.insurer.addresses[0].post_addr_house
        );
    },
  },
  computed: {
    day() {
      return moment(this.doc.DocumentDate).format("D");
    },
    month() {
      return moment(this.doc.DocumentDate).format("MMMM");
    },
    year() {
      return moment(this.doc.DocumentDate).format("Y");
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  font-size: 1.2em;
}
.subline {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.subtitle {
  text-align: center;
  font-weight: bold;
}
</style>
